class ContactForm {
  constructor() {
    this.form = document.getElementById('ContactForm');
    if (!this.form) return;

    this.init();
  }

  init() {
    this.form.addEventListener('submit', this.handleSubmit.bind(this));
    this.addFieldValidation();
  }

  addFieldValidation() {
    const requiredFields = this.form.querySelectorAll('[required]');

    requiredFields.forEach((field) => {
      field.addEventListener('blur', () => this.validateField(field));
      field.addEventListener('input', () => this.clearFieldError(field));
    });
  }

  validateField(field) {
    const value = field.value ? field.value.trim() : '';
    const fieldWrapper = field.closest('.field');

    // Check if field is required and empty
    if (field.hasAttribute('required')) {
      if (field.type === 'checkbox') {
        if (!field.checked) {
          this.showFieldError(field, 'Debes aceptar las condiciones legales');
          return false;
        }
      } else {
        if (!value) {
          this.showFieldError(field, 'Este campo es obligatorio');
          return false;
        }
      }
    }

    // Email validation
    if (field.type === 'email' && value && !this.isValidEmail(value)) {
      this.showFieldError(field, 'Por favor, introduce un email válido');
      return false;
    }

    return true;
  }

  showFieldError(field, message) {
    const fieldWrapper = field.closest('.field');
    const existingError = fieldWrapper.querySelector('.field-error');

    if (existingError) {
      existingError.remove();
    }

    const errorElement = document.createElement('small');
    errorElement.className = 'field-error contact__field-error';
    errorElement.textContent = message;

    // Insert error inside the field
    fieldWrapper.appendChild(errorElement);
    field.setAttribute('aria-invalid', 'true');
    fieldWrapper.classList.add('field--with-error');
  }

  clearFieldError(field) {
    const fieldWrapper = field.closest('.field');
    const errorElement = fieldWrapper.querySelector('.field-error');

    if (errorElement) {
      errorElement.remove();
    }

    field.removeAttribute('aria-invalid');
    fieldWrapper.classList.remove('field--with-error');
  }

  isValidEmail(email) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  }

  handleSubmit(event) {
    // Clear all previous errors first
    const allFields = this.form.querySelectorAll('.field');
    allFields.forEach((field) => {
      const input = field.querySelector('input, textarea, select');
      if (input) {
        this.clearFieldError(input);
      }
    });

    // Validate all required fields
    const requiredFields = this.form.querySelectorAll('[required]');
    let isValid = true;

    requiredFields.forEach((field) => {
      if (!this.validateField(field)) {
        isValid = false;
      }
    });

    if (!isValid) {
      // Prevent form submission
      event.preventDefault();

      // Focus on first error field
      const firstError = this.form.querySelector('[aria-invalid="true"]');
      if (firstError) {
        firstError.focus();
      }
      return false;
    }

    // If validation passes, show loading state
    const submitButton = this.form.querySelector('button[type="submit"]');
    const originalText = submitButton.textContent;
    submitButton.textContent = 'Enviando...';
    submitButton.disabled = true;

    // Allow form to submit naturally - don't prevent default
    return true;
  }
}

// Initialize when DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
  new ContactForm();
});
